!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("prop-types")) : "function" == typeof define && define.amd ? define(["react", "prop-types"], t) : "object" == typeof exports ? exports.ReactCodeSplitting = t(require("react"), require("prop-types")) : e.ReactCodeSplitting = t(e.react, e["prop-types"]);
}(this, function (e, t) {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;
      var r = n[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, o) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: o
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "/", t(t.s = 0);
  }([function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function u(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function c(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var p = n(1),
        i = o(p),
        a = n(2),
        f = o(a),
        l = function (e) {
      function t() {
        var e,
            n,
            o,
            c,
            p = this;
        r(this, t);

        for (var a = arguments.length, f = Array(a), l = 0; l < a; l++) {
          f[l] = arguments[l];
        }

        return n = o = u(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(f))), o.componentWillMount = function () {
          o.cancelUpdate = !1, o.props.load.then(function (e) {
            o.C = e, o.cancelUpdate || o.forceUpdate();
          });
        }, o.componentWillUnmount = function () {
          o.cancelUpdate = !0;
        }, o.render = function () {
          var e = o.props.componentProps;
          return o.C ? o.C.default ? i.default.createElement(p.C.default, e) : i.default.createElement(p.C, e) : null;
        }, c = n, u(o, c);
      }

      return c(t, e), t;
    }(i.default.Component);

    t.default = l, l.propTypes = {
      load: f.default.instanceOf(Promise).isRequired
    };
  }, function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }]);
});